import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

interface MesoDisplayAdsGroupType {
  type: string;
  className?: string;
}

export class MesoDisplayAdsGroup extends React.Component<MesoDisplayAdsGroupType> {
  public static get adType() {
    return {
      MESO_CM_ADS: 'mesoCMAds',
      MESO_SIDE_RAILS_ADS: 'mesoSideRails'
    };
  }

  public render() {
    const { type } = this.props;
    switch (type) {
      case MesoDisplayAdsGroup.adType.MESO_CM_ADS:
        return this._getCMAdMarkup();
      case MesoDisplayAdsGroup.adType.MESO_SIDE_RAILS_ADS:
        return this._getRightRailAdMarkup();
    }
  }

  private _getRightRailAdMarkup() {
    return (
      <div className="meso-display-ad all-l-margin-six">
        <ErrorBoundary label="meso.display.ad">
          <meso-display-ad uci="R1" slot="R1" />
          <meso-intent-media-search-compare
            slot="intentMediaAdPlacement"
            class="all-t-padding-three meso-side-intent-media-ads"
          />
          <meso-display-ad uci="R2" slot="R2" class="all-t-padding-three all-b-padding-three meso-r2" />
        </ErrorBoundary>
      </div>
    );
  }

  private _getCMAdMarkup() {
    return (
      <ErrorBoundary label="meso.display.ad">
        <meso-display-ad uci="CM1" slot="CM1" />
        <meso-display-ad uci="CM2" slot="CM2" />
        <meso-display-ad uci="CM3" slot="CM3" />
      </ErrorBoundary>
    );
  }
}
